var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mainContPage" }, [
    _c(
      "div",
      {
        staticClass: "top-logo",
        class: { postnord: _vm.brand === "postnord" },
      },
      [_c("img", { attrs: { src: _vm.brandSrc, alt: "" } })]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "search-result-box" },
      [
        !["postnord", "Yusen"].includes(_vm.brand)
          ? _c(
              "div",
              { staticClass: "radio-type" },
              [
                _c(
                  "el-radio",
                  {
                    attrs: { label: "" },
                    model: {
                      value: _vm.trackType,
                      callback: function ($$v) {
                        _vm.trackType = $$v
                      },
                      expression: "trackType",
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("trackingNo")))]
                ),
                _vm._v(" "),
                _c(
                  "el-radio",
                  {
                    attrs: { label: "0" },
                    model: {
                      value: _vm.trackType,
                      callback: function ($$v) {
                        _vm.trackType = $$v
                      },
                      expression: "trackType",
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("consignmentId")))]
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("SearchAndResults", { attrs: { "track-type": _vm.trackType } }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }